import React from 'react';
import { Skeleton } from '@mui/material';
import CenteredContainer from '@/common/CenteredContainer';
import css from './MultiRecipeSelection.module.css';

function MultiRecipeSelectionSkeleton(): JSX.Element {
  return (
    <>
      <CenteredContainer>
        <div className={css.container} data-testid="multi-recipe-selection-loaders">
          <Skeleton variant="rectangular" height={48} width={250} className={css['upcharge-recipes__heading']} />
          <Skeleton
            key="cyo-skeleton"
            variant="rectangular"
            height={138}
            className={css['product-tile__skeleton']}
          />

          <Skeleton variant="rectangular" height={32} width={200} className={css['upcharge-recipes__heading']} />
          <div className={css['upcharge-recipes__container']}>
            {
            Array.from({ length: 7 }, (_, k) => (
              <Skeleton
                key={k}
                variant="rectangular"
                height={138}
                className={css['product-tile__skeleton']}
              />
            ))
          }
          </div>
        </div>
      </CenteredContainer>
    </>
  );
}

export default MultiRecipeSelectionSkeleton;
